import {
  NOT_AVAILABLE_SOLD_STATUS,
  type Filter,
} from 'contexts/preferences/listing-params/types';
import type { InsightsListingType } from 'data/insights/types';

/**
 * The market the Insights tab describes for the applied filters. Rentals win over the
 * sold status (a leased search is still the rental market); any other off-market status
 * keeps the for-sale report.
 */
export function getInsightsListingType(filter: Pick<Filter, 'rental' | 'status'>): InsightsListingType {
  if (filter.rental) return 'rent';
  if (filter.status === NOT_AVAILABLE_SOLD_STATUS) return 'sold';
  return 'sale';
}
